import anime from 'animejs';

const TRANSLATE_DELTA = 60;

export default {
  transition: {
    css: false,
    mode: 'out-in',
    enter(targets, complete) {
      let content = targets.querySelectorAll('.grid-item > *');
      let translateX = 0;
      let translateY = 0;

      this.$nuxt.$emit('unlockViewport');

      content = Array.prototype.filter.call(content, (el) => {
        return el.getBoundingClientRect().top < window.innerHeight;
      });

      switch (this.$store.getters.transitionDirection) {
        case '<':
          translateX = -TRANSLATE_DELTA;
          break;
        case '>':
          translateX = TRANSLATE_DELTA;
          break;
        default:
          translateY = TRANSLATE_DELTA / 2;
          break;
      }

      this.$store.commit('transitionDirection', null);

      const anim = anime.timeline({
        begin() {
          anime.set(targets, {
            opacity: 1,
          });
        },
        complete,
      });

      anim
        .add({
          targets,
          translateX: [translateX, 0],
          translateY: [translateY, 0],
          translateZ: 0,
          duration: 400,
          easing: 'easeOutCubic',
        })
        .add(
          {
            targets: content,
            translateY: {
              value: [90, 0],
              duration: 850,
              easing: 'easeOutQuart',
            },
            opacity: {
              value: [0, 1],
              duration: 250,
              easing: 'easeInOutQuad',
            },
            translateZ: 0,
            delay: anime.stagger(40),
          },
          0
        );
    },
    leave(targets, complete) {
      let translateX = 0;
      let translateY = 0;

      this.$nuxt.$emit('lockViewport');

      this.$nextTick(() => {
        switch (this.$store.getters.transitionDirection) {
          case '<':
            translateX = TRANSLATE_DELTA;
            break;
          case '>':
            translateX = -TRANSLATE_DELTA;
            break;
          default:
            translateY = -TRANSLATE_DELTA / 2;
            break;
        }

        anime({
          targets,
          opacity: [1, 0],
          translateX: [0, translateX],
          translateY: [0, translateY],
          translateZ: 0,
          duration: 400,
          easing: 'easeInCubic',
          complete,
        });
      });
    },
  },
};
